import { Notification } from "element-ui";
import store from '@/store'

const pending = {};
const removePending = (key, isRequest = false) => {
  if (pending[key] && isRequest) {
    pending[key](`取消重复请求${decodeURIComponent(key)}`);
  }
  delete pending[key];
};
const getRequestIdentify = (config, isReuest = false) => {
  let url = config.url;
  if (isReuest) {
    url = config.baseURL + config.url.substring(1, config.url.length);
  }
  return config.method === "get"
    ? encodeURIComponent(url + JSON.stringify(config.params))
    : encodeURIComponent(config.url + JSON.stringify(config.data));
};

export default {
  /**
   * ajax 接口地址前缀，一般地留空即可。
   * 如果 ajax 接口地址太长，且有一致的前缀，则可以通过 serverBasePath 简化 index.js 中的接口长度。
   */
  serverBasePath: "",
  ajaxRequestFilter: function(axios) {
    return function(config) {
      // 拦截重复请求(即当前正在进行的相同请求)
      let requestData = getRequestIdentify(config, true);
      removePending(requestData, true);
  
      config.cancelToken = new axios.CancelToken(c => {
        pending[requestData] = c;
      });
      const _ENV_ = store.getters.userInfo;
      config.data = config.data || {}
      if(_ENV_ && _ENV_.secret && !config.data._ENV_) {
        if(config.data instanceof FormData){
          config.data.append('_ENV_[tickets]', _ENV_.tickets)
          config.data.append('_ENV_[secret]', _ENV_.secret)
          config.data.append('_ENV_[name]', _ENV_.name)
          config.data.append('_ENV_[showMenu]', _ENV_.showMenu)
        }else {
          Object.assign(config.data, { _ENV_ });
        }
      }
      return config;
    }
  },
  ajaxRequestError: function(error) {
    return Promise.reject(error);
  },
  /**
   * ajax 响应数据全局性处理函数。
   * @response
   *  config: http请求参数
   *  headers: 响应头数据
   *  data:	响应内容(JSON)
   *  status: 状态码
   *
   * 一般地，ajax接口返回的数据格式需要遵循一定的规范，如：
   *
   * 调用成功时：
   * {
   *   "ret": 1,
   *   "data": {
   *     "list": ""
   *   }
   * }
   * 调用失败时：
   * {
   *   "ret": 0,
   *   "error": {
   *     "name": "Exception",
   *     "code": 0,
   *     "type": "yii\\base\\UserException",
   *     "msg": "aa"
   *   }
   * }
   *
   * 此处的 ajaxResponseFilter 配置，可以用于全局地，对响应内容做一些预处理操作.
   */
  ajaxResponseFilter: function({ config, data: { ret, data, error = {} } }) {
    // 把已经完成的请求从 pending 中移除
    removePending(getRequestIdentify(config));
    
    if (ret === 0) {
      if([1100001].indexOf(error.code) > -1) {
        store.dispatch('addLoginCount');
        store.dispatch('getUserInfo');
      } else {
        Notification.error({
          title: "提 示",
          message: error.msg
        });
        if([1100004].indexOf(error.code) > -1) store.dispatch('getUserInfo');
      }
      return Promise.resolve({ ret, data: {}, error });
    }

    return { ret, data, error };
  },
  ajaxResponseError: error => {
    return Promise.resolve({
      ret: 0,
      data: {},
      error,
    });
  }
};
